import MeScroll from './mescroll/mescroll.m'
import {_} from './util'

export default{
	bind: function (element, binding,vnode) {
		let refs = 'dataList',
			wrapId = vnode.context.$refs[refs]
			
		if(!_.isEmpty(binding.modifiers)){
			refs = 'dataList'+binding.value
			wrapId = vnode.context.$refs[refs]
			
			if(_.isArray(wrapId)&&wrapId.length>0){
				wrapId = wrapId[0]
			}
			
//			console.log('vnode.context.$refs')
//			console.log(vnode.context.$refs)
		}
		
		//等待dom渲染完毕后再初始化mescroll，否则在多mescroll时会有bug
		vnode.context.$nextTick(()=>{
			vnode.context.mescroll = new MeScroll(element, { //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
				up: {
					callback: vnode.context.upCallback, //上拉回调
					//以下参数可删除,不配置
					use: true,
					isBoth: false,
					noMoreSize: 1,
					isBounce: false, //此处禁止ios回弹,解析(务必认真阅读,特别是最后一点): http://www.mescroll.com/qa.html#q10
					page:{
						num: vnode.context.pageIndex,
						size: vnode.context.pageSize
					}, //可配置每页8条数据,默认10
					toTop:{ //配置回到顶部按钮
						src : "/static/img/student/back-top.png", //默认滚动到1000px显示,可配置offset修改
						//html: null, //html标签内容,默认null; 如果同时设置了src,则优先取src
						//offset : 1000
					},
					empty:{ //配置列表无任何数据的提示
						warpId: wrapId,
						icon : "https://sp1.xiao360.com/static/img/student/nodata.png" , 
					  	tip : vnode.context.noDataText||"对不起，没有数据哦" 
					},
					htmlNodata: '<p class="upwarp-nodata">没有更多了</p>',
				},
				down: {
					callback: vnode.context.downCallback,				
				}			
			});
		})
	},
	unbind: function (el, binding, vnode){		
		vnode.context.mescroll.destroy()
	}
}



// WEBPACK FOOTER //
// ./src/libs/mescroll.directive.js